import { createStore, applyMiddleware, compose } from 'redux';
import { apiMiddleware } from 'redux-api-middleware';
import rootReducer from './reducers';
export default function configureStore(preloadedState) {
    return createStore(rootReducer, preloadedState || {}, compose(applyMiddleware(apiMiddleware)));
}
